export const componentList = [
  // 计划书2.0
  'person/personV2',
  'insResult/insResultV2',
  'insTypeResult/insTypeResultV2',
  'toggleTemp/toggleTempRightV2',
  'footer/cardFunctionBarV2',
  'nameExplainV2',
  'risk/riskV2',
  'insuranceClauseV2',
  // 计划书2.0 --end
  'loading/bxsBg',
  'banner/advertising',
  'person/person',
  'person/newInsureDetail',
  'liability/category',
  'liability/accountLiab',
  'insResult/insResult',
  'insTypeResult/insTypeResult',
  'demonstration/demons',
  'footer/cardFunctionBar',
  'footer/miniprogramFooter',
  // 'termsEnter/termsList',
  'insuranceClause',
  'risk/risk',
  'toggleTemp/toggleTempRight',
  'diseaseType/diseaseType',
  'diseaseType/diseaseTypeNew',
  'actionSheet/actionSheet',
  'drawer/ExportSelection/ExportSelection'
]
